import { render, staticRenderFns } from "./GenericConfigurationCard.vue?vue&type=template&id=157ed776&scoped=true"
import script from "./GenericConfigurationCard.vue?vue&type=script&lang=js"
export * from "./GenericConfigurationCard.vue?vue&type=script&lang=js"
import style0 from "./GenericConfigurationCard.vue?vue&type=style&index=0&id=157ed776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157ed776",
  null
  
)

export default component.exports